import { Download } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { FC } from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DownloadMittelabrufPDF } from 'src/pages/private/online-antrag/DownloadAntragPDF';

// import schemas
// import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
// const P = Schema.attributes;

const MAHerunterladen: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	const { application, readOnly, saveApplication } = useApplication();
	const handleDownloadAntrag = () => {
		DownloadMittelabrufPDF(application, readOnly, saveApplication);
	};
	return (
		<>
			<ApplicationHeading title={untertitel} />
			<MarkdownRenderer markdown={inhalt} />

			<Button variant='outlined' startIcon={<Download />} onClick={() => handleDownloadAntrag()}>
				Mittelabruf herunterladen
			</Button>
		</>
	);
};

export default MAHerunterladen;
